import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Role } from 'src/app/model/roles';

@Injectable({
    providedIn: 'root'
})
export class RoleEntityService extends EntityCollectionServiceBase<Role> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Role', serviceElementsFactory);
    }
}
